import { routes } from '../routes/routes';

const AUTH_RETURN_URL_KEY = 'werule_auth_return_url';

function isGuestIntakePath(path: string): boolean {
  return path === routes.GUEST_INTAKE || path.startsWith(`${routes.GUEST_INTAKE}?`);
}

function usesFallbackDirectly(path: string): boolean {
  if (isGuestIntakePath(path)) {
    return true;
  }
  if (path === routes.profile || path.startsWith('/mentor/') || path.startsWith('/mentee/')) {
    return true;
  }
  return false;
}

let authRedirectHandled = false;

export function saveAuthReturnUrl(path: string): void {
  sessionStorage.setItem(AUTH_RETURN_URL_KEY, path);
  authRedirectHandled = false;
}

export function peekAuthReturnUrl(): string | null {
  const stored = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  if (!stored || !stored.startsWith('/')) {
    return null;
  }
  return stored;
}

export function consumeAuthReturnUrl(fallback: string): string {
  const stored = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  sessionStorage.removeItem(AUTH_RETURN_URL_KEY);
  if (!stored || !stored.startsWith('/')) {
    return fallback;
  }
  return stored;
}

/** Skip Login/Register auto-redirect when an auth handler is finishing redirect. */
export function shouldDeferAutoAuthRedirect(): boolean {
  return authRedirectHandled;
}

/** Full-page navigation after auth so return URL is not lost to a SPA race. */
export function completeAuthRedirect(fallback: string): void {
  authRedirectHandled = true;
  // Guest intake and own-profile destinations must not be overridden by a saved return URL.
  const destination = usesFallbackDirectly(fallback) ? fallback : consumeAuthReturnUrl(fallback);
  window.location.assign(destination);
}
